import { Mui } from "@osu/react-ui";
import { useState } from "react";
import PersonSearch from "./PersonSearch";
import AdvancedSearch from "./AdvancedSearch";
import { clear } from "../../services/graphql/slices/search-slice";
import { useDispatch } from "react-redux";
import useRoleAuthentication from "../../Authentication/hooks/useRoleAuthentication";

function Search() {
    const [currentTab, setCurrentTab] = useState(0);
    const dispatch = useDispatch();
    const authDetails = useRoleAuthentication();

    const handleTabChange = (e, newValue) => {
        dispatch(clear());
        setCurrentTab(newValue);
    }

    const hasAccess = authDetails?.isAnyAdmin || authDetails?.isHonorsSeasonalManager || authDetails?.isHonorsProgramCoordinator;

    return (
        <Mui.Box sx={{ width: '100%' }}>
            <Mui.Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Mui.Tabs value={currentTab} onChange={handleTabChange} aria-label="Search navigation">
                    <Mui.Tab label="Person Search" id="personsearch-tab-0" aria-controls="personsearch-tabpanel-0" />
                    {hasAccess && <Mui.Tab label="Advanced Search" id="advancedsearch-tab-1" aria-controls="advancedsearch-tabpanel-1" />}
                </Mui.Tabs>
            </Mui.Box>
            <div
                role="tabpanel"
                hidden={currentTab !== 0}
                id={`personsearch-tabpanel-0`}
                aria-labelledby={`personsearch-tab-0`}
            >
                {currentTab === 0 && <Mui.Box className="margin-top-2">
                    <PersonSearch />
                </Mui.Box>}
            </div>
            {hasAccess && (<div
                role="tabpanel"
                hidden={currentTab !== 1}
                id={`advancedsearch-tabpanel-1`}
                aria-labelledby={`advancedsearch-tab-1`}
            >
                {currentTab === 1 && <Mui.Box className="margin-top-2">
                    <AdvancedSearch />
                </Mui.Box>}
            </div>)}
        </Mui.Box>
    );
}

export default Search;